import { __rest } from 'tslib';
import React__default, { useEffect } from 'react';
import { Overlay } from './Overlay.es.js';
import { SizeEnum } from '@teko/types/ds';
import { getScrollbarWidth, pixelParse } from '../../helpers/utils.es.js';
import styled from '@emotion/styled';

const Modal = (_a) => {
    var { show, onHide, children, size = SizeEnum.m, backDropStyle, parent } = _a, props = __rest(_a, ["show", "onHide", "children", "size", "backDropStyle", "parent"]);
    const parentElement = typeof document !== 'undefined' ? parent || document.body : null;
    useEffect(() => {
        if (typeof document !== 'undefined') {
            if (show) {
                parentElement.style.overflow = 'hidden';
                parentElement.style.paddingRight = `${getScrollbarWidth()}px`;
            }
        }
        return () => {
            parentElement.style.overflow = 'unset';
            parentElement.style.paddingRight = 'unset';
        };
    }, [show]);
    if (!show)
        return null;
    return (React__default.createElement(Overlay, { parent: parentElement, show: show, onEscPressed: onHide },
        React__default.createElement(Backdrop, { onClick: onHide, style: backDropStyle }),
        React__default.createElement(ModalContent, Object.assign({ size: size }, props), children)));
};
const Backdrop = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: -1000;
`;
const sizeMaps = {
    [SizeEnum.s]: '400px',
    [SizeEnum.m]: '700px',
    [SizeEnum.l]: '960px',
};
const ModalContent = styled.div(({ theme, size, width, maxHeight, borderRadius, backgroundColor, }) => `
    background-color: ${backgroundColor || theme.colors.white};
    display: flex;
    flex-direction: column;
    width: ${width !== undefined ? pixelParse(width) : sizeMaps[size]};
    border-radius: ${borderRadius || theme.borderRadius.m};
    max-height: ${maxHeight || '90%'};
    z-index: 1060;
    position: relative;
    overflow-y: auto;
  `);

export { Modal };
